import { PapiComment, PapiDeviation } from '@wix/da-papi-types';

export const isActionable = ({ isOwner, isAuthor, isReportable, isSpam }: PapiComment): boolean => {
  return (isOwner || isAuthor || isReportable) && !isSpam;
};

export function canPeek(comment: PapiComment) {
  // $canPeek = ($is_admin_mode && ($is_hidden || $is_admin_hidden || $is_spam || $is_deleted)) // admin can see all
  //         || ($is_owner && (($is_hidden && !$is_admin_hidden) || $is_spam)) // owner can see owner-hidden or spam
  //         || ($is_author && $is_deleted); // author can see deleted

  if (comment.isOwner) {
    // owner can see owner-hidden
    if (comment.isHidden && !comment.isAdminHidden) {
      return true;
    }
    // and spam
    if (comment.isSpam) {
      return true;
    }
  }

  if (comment.isAuthor) {
    // comment author can see deleted
    if (comment.isDeleted) {
      return true;
    }
  }

  return false;
}

export function isCommentHidden(
  { isDeleted, isHidden, isAdminHidden, isSpam, replies }: PapiComment,
  isPeeking: boolean
) {
  // these rules match those in CommentBody
  const isVisible = !isAdminHidden && !isDeleted;

  if (!isPeeking && isSpam && replies !== 0) {
    return true;
  }

  if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
    return true;
  }

  if ((isHidden || !isVisible || isSpam) && !isPeeking) {
    return true;
  }

  return false;
}

export function getCommentNotificationQueue({ commentId }: PapiComment) {
  return `comment-${commentId}`;
}

export function generateReplyEditorId(comment: PapiComment): string {
  return `reply-${comment.commentId}`;
}

/**
 * Extracts the deviation from a da-exclusive-avatar node in comment's TipTap content.
 * Returns the first deviation found, or undefined if none exists.
 */
export function extractExclusiveAvatarDeviation(comment: PapiComment): PapiDeviation | undefined {
  try {
    const html = (comment as any)?.textContent?.html;
    if (!html || typeof html !== 'object' || html.type !== 'tiptap') {
      return undefined;
    }
    const markup = (html as any).markup;
    if (!markup || typeof markup !== 'string') {
      return undefined;
    }
    const parsed = JSON.parse(markup);
    const doc = parsed?.document || parsed; // support both {document} and raw doc
    const nodes: any[] = [];
    const walk = (node: any) => {
      if (!node) return;
      if (Array.isArray(node)) {
        node.forEach(walk);
        return;
      }
      if (node.type === 'da-exclusive-avatar' && node.attrs?.deviation) {
        nodes.push(node);
      }
      if (node.content) walk(node.content);
    };
    walk(doc?.content);
    return nodes[0]?.attrs?.deviation;
  } catch (e) {
    return undefined;
  }
}
